import { render, staticRenderFns } from "./CaixaDeChecagem.vue?vue&type=template&id=6a485d5b"
import script from "./CaixaDeChecagem.vue?vue&type=script&lang=js"
export * from "./CaixaDeChecagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports